<template>
    <div class="search_nodata">
        <div class="img_wrap" v-if="showemptyData">
            <img src="../../assets/images/parent-course/search-nodata.png" alt="">
            <p class="desc_text">{{tipText}}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'empty-data',
  components: {},
  props: {
    showemptyData: {
        type: Boolean,
        default:false
    },
    tipText:{
        type: String,
        default:''
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang='scss'>
.search_nodata {
    .img_wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 233px;
        height: 231px;
        img {
            width: 100%;
        }
        p {
            height: 20px;
            line-height: 20px;
            color: #000;
            font-size: 14px;
        }
    }
}
</style>

